import { render, staticRenderFns } from "./PabauAppointments.vue?vue&type=template&id=7eb0ffc1"
import script from "./PabauAppointments.vue?vue&type=script&lang=js"
export * from "./PabauAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports